export default __webpack_public_path__ + "static/media/somalia.0d40d424.jpg";